import { render } from "./ErrorDetailsTable.vue?vue&type=template&id=163378e9&scoped=true"
import script from "./ErrorDetailsTable.vue?vue&type=script&lang=js"
export * from "./ErrorDetailsTable.vue?vue&type=script&lang=js"

import "./ErrorDetailsTable.vue?vue&type=style&index=0&id=163378e9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-163378e9"]])

export default __exports__